import React from "react";
import { Dialog, DialogContent, IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InitiateMovementForm from "./InitiateMovementForm";

const InitiateMovementEditFormDialog = ({
  refetch,
  open,
  onClose,
  movementData,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <Box
        sx={{
          position: "absolute",
          top: 8,
          right: 8,
          zIndex: 1,
        }}
      >
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent dividers sx={{ pt: 4 }}>
        <InitiateMovementForm
          mode="edit"
          initialData={movementData}
          onClose={onClose}
          onSuccess={(updated) => {
            refetch();
            onClose();
          }}
          sx={{ mt: 0, p: 0, boxShadow: "none" }}
          contentSx={{ p: 1 }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default InitiateMovementEditFormDialog;
